import React, { Fragment } from 'react';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faTimes } from '@fortawesome/free-solid-svg-icons';

const Filter = ({
  columns,
  init,
  customClassName,
}) => {
  return (
    <Fragment>
      <div className={`filter ${customClassName || ''}`}>
        {columns.map((column, index) => {
          switch(column.type) {
            case 'select':
              return (
                <div key={index} className='filter-item-wrap'>
                  <select
                    required
                    className={column.size || ''}
                    value={column.value}
                    onChange={e => column.action(_.set({}, column.key, e.target.value), false)} //디바운싱 사용 구분을 위해 false 추가(true시 사용)
                  >
                    <option value='' hidden>{column.placeholder}</option>
                    {column.selectItems.map((item, index) => (
                      <option key={index} value={item[column.selectItemValue]}>{item[column.selectItemKey]}</option>
                    ))}
                  </select>
                  <span
                    className='filter-item-remove-button'
                    hidden={!column.value || !column.isRemoveButton}
                    onClick={() => column.action(_.set({}, column.key, ''), false)} //디바운싱 사용 구분을 위해 false 추가(true시 사용)
                  >
                    <FontAwesomeIcon icon={faTimes}/>
                  </span>
                </div>
              )
            case 'datePicker':
              return (
                <div key={index} className='filter-item-wrap'>
                  <DatePicker
                    key={index}
                    dateFormat={column.dateFormat || 'yyyy-MM-dd HH:mm'}
                    placeholderText={column.placeholder}
                    selected={column.value}
                    selectsStart={column.selectsStart}
                    selectsEnd={column.selectsEnd}
                    minDate={column.minDate}
                    maxDate={column.maxDate}
                    startDate={column.startDate}
                    endDate={column.endDate}
                    showTimeSelect={column.showTimeSelect}
                    timeFormat='HH:mm'
                    timeIntervals={60}
                    timeCaption='Time'
                    onChange={date => column.action(_.set({}, column.key, date), false)} //디바운싱 사용 구분을 위해 false 추가(true시 사용)
                    disabled={column.disabled}
                  />
                  <span
                    className='filter-item-remove-button'
                    hidden={!column.value || !column.isRemoveButton}
                    onClick={() => column.action(_.set({}, column.key, ''), false)} //디바운싱 사용 구분을 위해 false 추가(true시 사용)
                  >
                    <FontAwesomeIcon icon={faTimes}/>
                  </span>
                </div>
              )
            default: 
              return (
                <div key={index} className='filter-item-wrap'>
                  <input
                    className={column.size || ''}
                    placeholder={column.placeholder}
                    value={column.value}
                    onChange={e => column.action(_.set({}, column.key, e.target.value), true)} //디바운싱 사용 구분을 위해 true 추가
                    hidden={column.hidden}
                  />
                  <span
                    className='filter-item-remove-button'
                    hidden={!column.value}
                    onClick={() => column.action(_.set({}, column.key, ''), false)} //디바운싱 사용 구분을 위해 false 추가(true시 사용)
                  >
                    <FontAwesomeIcon icon={faTimes}/>
                  </span>
                </div>
              )
          }
        }
        )}
        <button className='init-filter' onClick={() => init()}>
          <FontAwesomeIcon icon={faEraser} style={{color:'#282C34', paddingRight:'3px'}}/>
          Clear
        </button>
      </div>
    </Fragment>
  );
};

export default Filter;